import { Loader2 } from "lucide-react";
import { cn } from "@/shared/lib/cn.js";

/** @param {{ className?: string }} props */
export function Spinner({ className }) {
  return <Loader2 className={cn("h-4 w-4 animate-spin", className)} aria-hidden="true" />;
}

/**
 * Estado de carregamento de tela inteira, com a mesma aparência em todos os
 * módulos (o app antigo repetia esse bloco em cada rota).
 * @param {{ message?: string, className?: string }} props
 */
export function LoadingState({ message = "Carregando...", className }) {
  return (
    <div
      className={cn(
        "flex h-[60vh] flex-col items-center justify-center gap-2 text-muted-foreground",
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <Spinner className="h-8 w-8 text-primary" />
      <p className="text-sm">{message}</p>
    </div>
  );
}

/**
 * Estado vazio padrão.
 * @param {{ icon?: React.ElementType, title: string, description?: string,
 *           action?: React.ReactNode, className?: string }} props
 */
export function EmptyState({ icon: Icon, title, description, action, className }) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-12 text-center", className)}>
      {Icon && (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
          <Icon className="h-6 w-6 text-muted-foreground" />
        </div>
      )}
      <p className="text-sm font-medium">{title}</p>
      {description && <p className="mt-1 text-xs text-muted-foreground">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
